var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopymin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "#3D3D3D",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.442 16.391-4-4c-.25-.25-.59-.39-.943-.39h-1.333v-1.334c0-.353-.14-.692-.39-.942l-4-4c-.25-.25-.59-.39-.943-.391h-4a2.667 2.667 0 0 0-2.667 2.667v9.333a2.667 2.667 0 0 0 2.667 2.667h4v4a2.667 2.667 0 0 0 2.666 2.666h6.667a2.666 2.666 0 0 0 2.667-2.666v-6.667c0-.354-.14-.693-.391-.943m-2.828.943h-2.115v-2.115zm-6.667-6.667h-2.114V8.553zm-2.114 4v2.667h-4V8.001h2.666v3.333a.667.667 0 0 0 .667.667h3.333a2.667 2.667 0 0 0-2.666 2.666m2.666 9.334v-9.334h2.667v3.334a.667.667 0 0 0 .667.666h3.333v5.334z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopymin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.min.b712a33d1c9bdbef8248b64c3042ee97.svg";